//#region import
import React, { useState } from 'react';
// custom components //
import { BookingForm, EmptyPage } from "_molecules";

// icons
import { IoLockClosedOutline } from 'react-icons/io5';

// redux
import { useSelector } from 'react-redux';
import { selectUserDb } from '_redux/slices/main-screen/user';
import { selectConfirmBookingError } from '_redux/slices/prm-bookings/bookings';

// styles
import { Colors } from '_styles';
//#endregion

const CreateBooking = () => {
    const dbUser = useSelector(selectUserDb);
    const confirmError = useSelector(selectConfirmBookingError);

    if (!dbUser) {
        return (
            <div style={styles.emptyWrapper}>
                <div style={styles.emptyCard}>
                    <IoLockClosedOutline size={48} color={Colors.GRAY_MEDIUM} />
                    <EmptyPage
                        title="Requires Verified Account"
                        subtitle="In order to make assistance bookings your account must be verified"
                        subsubtitle="Please check back once your account has been verified"
                    />
                </div>
            </div>
        );
    }

    return (
        <div style={styles.wrapper}>
            <BookingForm />
            {confirmError && (
                <div style={styles.errorBanner}>
                    <p style={styles.errorText}>{confirmError}</p>
                </div>
            )}
            <div style={{ paddingBottom: 60 }} />
        </div>
    );
};

const styles = {
    wrapper: {
        maxWidth: 960,
    },
    emptyWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 80,
    },
    emptyCard: {
        textAlign: 'center',
        padding: 40,
        background: Colors.GRAY_LIGHT,
        borderRadius: 16,
        maxWidth: 480,
    },
    errorBanner: {
        marginTop: 16,
        padding: '12px 16px',
        background: Colors.LIGHT_RED,
        borderRadius: 8,
        borderLeft: `4px solid ${Colors.DARK_RED}`,
    },
    errorText: {
        color: Colors.DARK_RED,
        margin: 0,
        fontSize: 14,
        fontWeight: 500,
    },
};

export default CreateBooking;
